import { render } from "./FoldingToggleComponent.vue?vue&type=template&id=6f886e92"
import script from "./FoldingToggleComponent.vue?vue&type=script&lang=js"
export * from "./FoldingToggleComponent.vue?vue&type=script&lang=js"

import "./FoldingToggleComponent.vue?vue&type=style&index=0&id=6f886e92&lang=css"

import exportComponent from "/home/user/ade-home/chantiervocal/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__